/*
 * -----------------------------------------------------------------------
 *  <copyright file="grid-menu-item/index.tsx" company="Triumph Research Intelligence">
 *      Copyright (C) 2023 by Triumph Research Intelligence. All rights reserved.
 *  </copyright>
 * -----------------------------------------------------------------------
 */

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import cn from 'clsx';
import React from 'react';
import DarkTooltip from '../../../dark-tool-tip/dark-tool-tip';
import { ExtraMenuItem } from '../grid-menu.interface';
import './styles.scss';
import { textToId } from '@utils/automation-test-helpers';

interface GridMenuItemProps {
    item: ExtraMenuItem;
    'data-testid'?: string;
}

const GridMenuItem = ({ item, 'data-testid': dataTestId }: GridMenuItemProps) => {
    return (
        <div className={cn('grid-menu-item', item.customClassName)}>
            <DarkTooltip title={item.tooltipTitle ?? ''} placement="top" arrow>
                <div>
                    <button
                        type="button"
                        onClick={() => (item.onClick ? item.onClick() : null)}
                        className="grid-action"
                        disabled={item.disabled}
                        // NOTE: the next line as well as <div> wrapper is a hack to show tooltip even for disabled element
                        style={item.disabled ? { pointerEvents: 'none' } : {}}
                        data-testid={dataTestId ?? textToId(item.tooltipTitle ?? '')}
                    >
                        {Array.isArray(item.icon) ? (
                            <FontAwesomeIcon icon={item.icon} style={{ fontSize: '18px' }} />
                        ) : (
                            // eslint-disable-next-line react/jsx-no-useless-fragment
                            <>{item.icon}</>
                        )}
                    </button>
                </div>
            </DarkTooltip>
        </div>
    );
};

export default GridMenuItem;
